/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CrudSystemActionSubject = {
    Model: 'Model',
    Process: 'Process',
    Action: 'Action',
    User: 'User',
    Group: 'Group',
    Role: 'Role',
    AuthConfig: 'AuthConfig',
    Setting: 'Setting',
    Development: 'Development',
    Slack: 'Slack'
} as const;
export type CrudSystemActionSubject = typeof CrudSystemActionSubject[keyof typeof CrudSystemActionSubject];


export function instanceOfCrudSystemActionSubject(value: any): boolean {
    for (const key in CrudSystemActionSubject) {
        if (Object.prototype.hasOwnProperty.call(CrudSystemActionSubject, key)) {
            if (CrudSystemActionSubject[key as keyof typeof CrudSystemActionSubject] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CrudSystemActionSubjectFromJSON(json: any): CrudSystemActionSubject {
    return CrudSystemActionSubjectFromJSONTyped(json, false);
}

export function CrudSystemActionSubjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrudSystemActionSubject {
    return json as CrudSystemActionSubject;
}

export function CrudSystemActionSubjectToJSON(value?: CrudSystemActionSubject | null): any {
    return value as any;
}

export function CrudSystemActionSubjectToJSONTyped(value: any, ignoreDiscriminator: boolean): CrudSystemActionSubject {
    return value as CrudSystemActionSubject;
}

